<template>
    <CInput type="text"
            inputmode="decimal"
            :class="['input-segmented',{'disabled': disabled, 'is-invalid': isValid === false}, {'is-valid': isValid === true}]"
            :value="localValue"
            :prepend="currencySymbol(currency)"
            :append="currency"
            :readonly="readonly"
            :disabled="disabled"
            :is-valid="isValid"
            @input="onInput"
            @change="onBlur"
            @keydown.native="onKeydown"
            />
</template>
<script>
export default {
  name: "PCurrencyInput",
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    step: {
      type: Number,
      default: 0.01
    },
    min: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: [Boolean, Function],
      default: null
    }
  },
  data() {
    return {
      localValue: this.formatValue(this.value),
      editing: false
    }
  },
  watch: {
    value(newVal) {
      if (this.editing) return
      this.localValue = this.formatValue(newVal)
    }
  },
  methods: {
    formatValue(val) {
      if (val === null || val === '') return ''
      const num = parseFloat(val)
      if (isNaN(num)) return ''
      return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    parseLocaleNumber(str) {
      if (!str) return NaN
      const cleaned = String(str).replace(/\s/g, '')
      const decimalSep = (1.1).toLocaleString(undefined).charAt(1)
      const thousandSep = decimalSep === ',' ? '.' : ','
      const normalized = cleaned.replace(new RegExp('\\' + thousandSep, 'g'), '').replace(decimalSep, '.')
      return parseFloat(normalized)
    },
    onKeydown(e) {
      const allowed = /[0-9., ]/
      if (
        allowed.test(e.key) ||
        ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape',
         'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
         'Home', 'End'].includes(e.key) ||
        e.ctrlKey || e.metaKey
      ) return
      e.preventDefault()
    },
    onInput(value) {
      this.editing = true
      this.localValue = String(value).replace(/[^0-9., ]/g, '')
      const num = this.parseLocaleNumber(this.localValue)
      this.$emit('update:value', isNaN(num) ? null : parseFloat(num.toFixed(2)))
      this.$emit('input', isNaN(num) ? null : parseFloat(num.toFixed(2)))
    },
    onBlur(value) {
      this.editing = false
      if (!value && value !== 0) {
        this.$emit('update:value', null)
        this.$emit('input', null)
        return
      }
      const num = this.parseLocaleNumber(value)
      if (isNaN(num)) return
      const rounded = parseFloat(num.toFixed(2))
      this.localValue = this.formatValue(rounded)
      this.$emit('update:value', rounded)
      this.$emit('input', rounded)
      this.$emit('change', rounded)
    },
  }
}
</script>


<style scoped>
</style>
